import React, { useEffect, useState } from 'react';
import {
  FormControlLabel,
  RadioGroup,
  Grid,
  Radio,
  TextField,
  Checkbox,
  Button,
  Box,
  Typography,
  Chip,
  alpha,
  Paper,
  Container,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Autocomplete } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ComputerIcon from '@mui/icons-material/Computer';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ReceiptIcon from '@mui/icons-material/Receipt';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import SendIcon from '@mui/icons-material/Send';
import SaveIcon from '@mui/icons-material/Save';
import DescriptionIcon from '@mui/icons-material/Description';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import BuildIcon from '@mui/icons-material/Build';

import ModernTable, { ModernPageContainer, ModernPageHeader } from '../components/ModernTable';
import Title from '../Title';
import { useHistory } from 'react-router';
import LoadingIcon from '../../items/buttons/LoadingIcon';
import request from '../../../services/Request';
import moment from 'moment';
import Swal from 'sweetalert2';
import { CloudDownload } from '@mui/icons-material';
import { ExportToCsv } from 'export-to-csv';
import invoiceTemplate from './invoiceTemplate';
import tmctemplate from './tmcMagex';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import html2pdf from 'html2pdf.js';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const getAllEmployeesURL = `/magexuser/viewAllMagexUsers`;

export default function MagexSales(props) {
  const theme = useTheme();
  const history = useHistory();
  var date = new Date();
  const [startDate, setStartDate] = useState(new Date(date.getFullYear(), date.getMonth(), 1));
  const [endDate, setEndDate] = useState(new Date());
  const [groupV, setgroupV] = useState([]);
  const [groups, setGroups] = useState([]);
  const [ms, setMS] = useState([]);
  const [os, setOS] = useState([]);
  const [loading, setIsLoading] = useState(false);
  const [totalMachines, setTotalMachines] = useState(0);

  const [op, setop] = useState();

  const [serviceFee, setServiceFee] = useState(0);

  const [totalSales, setTotalSales] = useState(0);
  const [totalMonth, setTotalMonth] = useState(0);

  const [invoiceNO, setInvoiceNO] = useState(0);
  const [filtered, setFiltered] = useState([]);
  const [pdf, setPdf] = useState(null);
  const [enableDownLoad, setEnableDownload] = useState(false);
  const [filename, setFilename] = useState('');

  function monthsBetween(start, end) {
    const startDate = moment(start);
    const endDate = moment(end);

    // Calculate the difference in months
    const diffMonths = endDate.diff(startDate, 'months', true);

    // Round up to the nearest complete month
    const completeMonths = Math.ceil(diffMonths);

    return completeMonths;
  }

  const handleStartDate = (e) => {
    setStartDate(e);
  };

  const handleEndDate = (e) => {
    setEndDate(e);
  };

  useEffect(() => {
    let isCancelled = false;

    //getAllEmployees
    async function getAllEmployees() {
      setIsLoading(true);
      await request({
        method: 'get',
        url: getAllEmployeesURL,
      })
        .then((res) => {
          if (!isCancelled) {
            console.log('allusers', res.data);
            setGroups(res.data);
            setIsLoading(false);
          }
        })
        .catch(() => {
          Swal.fire({ text: 'Request Failed' });
          setIsLoading(false);
        });
    }

    getAllEmployees();

    return () => {
      isCancelled = true;
    };
  }, []);

  // useEffect(() => {
  //   let allMachines = [];
  //   let isCancelled = false;

  //   async function getGroups() {
  //     await request({
  //       method: 'get',
  //       url:
  //     }).then((res) => {
  //       if (!isCancelled) {
  //         setGroups(res.data.groups);
  //         setMachines(res.data.machines);
  //         setLoading(true);
  //         allMachines = res.data.machines.map((e) => e._id);
  //       }
  //     });
  //   }

  //   getGroups();

  //   return () => {
  //     isCancelled = true;
  //   };
  // }, []);

  const sendInvoice = () => {
    if (!groupV?.email) {
      return Swal.fire({
        text: 'No Email found for this user',
        timer: 2000,
      });
    }
    const std = moment(new Date(startDate)).format('YYYY-MM-DD');
    const edt = moment(new Date(endDate)).format('YYYY-MM-DD');
    request({
      method: 'post',
      url: '/magex/sendMagexInvoice',
      data: {
        users: [groupV],
        startDate: std,
        endDate: edt,
        invoiceNO: invoiceNO,
        filename: invoiceNO,
      },
    })
      .then((res) => {
        Swal.fire({
          text: `Send Invoice to ${groupV.email} Successfully`,
        });
      })
      .catch((err) => {
        Swal.fire({
          text: 'Send Invoice Failed',
        });
      });
  };

  const showInvoice = () => {
    //get total price of service fee from groupV's service. service array
    let machineString = '';
    filtered.forEach((mc, index) => {
      machineString += mc.machineId;
      if (index !== filtered.length - 1) {
        machineString += index === filtered.length - 2 ? ' & ' : ', ';
      }
    });

    const taxRate = groupV.tax ? parseFloat(groupV?.tax / 100) : 0;

    const invoiceData = {
      mcNO: filtered?.length,
      taxRate: taxRate,
      operator: groupV,
      serviceFee: serviceFee,
      license_fee: groupV.license_fee,
      invoiceNO: invoiceNO,
      machineString: machineString,
      today: moment(new Date()).format('YYYY/MM/DD'),
      startDate: moment(new Date(startDate)).format('YYYY/MM/DD'),
      endDate: moment(new Date(endDate)).format('YYYY/MM/DD'),
    };
    document.getElementById('invoicetpmagex').innerHTML = invoiceTemplate(invoiceData);
    document.getElementById('tmc_magexinvoice').innerHTML = tmctemplate(invoiceData);
    setEnableDownload(true);
    // //open new window
    // // Open a new window
    // var newWindow = window.open('', '_blank');

    // // Write the content of the div into the new window
    // newWindow.document.write(document.getElementById('download-invoice-magex-content').innerHTML);
    // newWindow.document.write('</body></html>');

    // // Close the document to ensure proper rendering
    // newWindow.document.close();
  };

  const columns = [
    {
      title: 'Machine ID',
      field: 'machineId',
      render: (rowData) => (
        <Chip
          icon={<ComputerIcon sx={{ fontSize: 16 }} />}
          label={rowData.machineId}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.info.main, 0.12),
            color: theme.palette.info.dark,
            border: `1.5px solid ${alpha(theme.palette.info.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.info.dark,
            },
          }}
        />
      ),
    },
    {
      title: 'Sales ($)',
      field: 'totalPrice',
      render: (rowData) => (
        <Chip
          icon={<AttachMoneyIcon sx={{ fontSize: 16 }} />}
          label={rowData.totalPrice?.toFixed(2) || '0.00'}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.success.main, 0.12),
            color: theme.palette.success.dark,
            border: `1.5px solid ${alpha(theme.palette.success.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.success.dark,
            },
          }}
        />
      ),
    },
    {
      title: 'Tax ($)',
      field: 'totalTax',
      render: (rowData) => (
        <Chip
          icon={<AccountBalanceIcon sx={{ fontSize: 16 }} />}
          label={rowData.totalTax?.toFixed(2) || '0.00'}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.warning.main, 0.12),
            color: theme.palette.warning.dark,
            border: `1.5px solid ${alpha(theme.palette.warning.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.warning.dark,
            },
          }}
        />
      ),
    },
    {
      title: 'Items Sold',
      field: 'totalItems',
      render: (rowData) => (
        <Chip
          icon={<ShoppingCartIcon sx={{ fontSize: 16 }} />}
          label={rowData.totalItems || 0}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.primary.main, 0.12),
            color: theme.palette.primary.dark,
            border: `1.5px solid ${alpha(theme.palette.primary.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.primary.dark,
            },
          }}
        />
      ),
    },
  ];

  const handleChange = async () => {
    // console.log('data', groupV);
    setIsLoading(true);
    setEnableDownload(false);
    const std = moment(new Date(startDate)).format('YYYY-MM-DD');
    const edt = moment(new Date(endDate)).format('YYYY-MM-DD');

    //get machine list from magex
    let magexmachinelist = [];
    try {
      magexmachinelist = await request({
        method: 'post',
        url: '/magex/magexmachinelist',
        data: {
          md5: groupV?.md5,
        },
      });
    } catch (err) {
      console.log('err', err);
      Swal.fire({
        title: 'Get Data Failed',
        text: JSON.stringify(err),
      });
      setIsLoading(false);
      return;
    }
    let machineList = magexmachinelist?.data?.machines;
    console.log('machineList', machineList);
    if (!machineList || machineList.length === 0) {
      setIsLoading(false);
      Swal.fire({
        title: 'No Machines Found',
        text: 'No machines found for this operator.',
        icon: 'info',
      });
      return;
    }

    machineList.forEach((element) => {
      element.totalItems = 0;
      element.totalPrice = 0;
      element.totalTax = 0;
      element.machineId = element.serial;
    });

    const magexUrl = '/getMagexSales';
    request({
      method: 'post',
      url: magexUrl,
      data: {
        md5: groupV?.md5,
        startDate: std,
        endDate: edt,
      },
    })
      .then((res) => {
        if (res.data?.length > 0) {
          const machineStats = [];
          console.log('res.data', res.data);
          setOS(res.data);
          res.data?.forEach((item) => {
            item.tax = item.tax ? item.tax : 0;
            const machineId = item.machine;
            // Check if this machine's statistics exist in machineStats
            const index = machineList.findIndex((stat) => stat.serial == machineId);
            console.log('index', index);
            // if (index === -1) {
            //   // If not exist, add new entry
            //   machineStats.push({
            //     machineId: machineId,
            //     totalPrice: item.price,
            //     totalTax: item.tax,
            //     totalItems: 1,
            //   });
            //   // console.log('machineStats', machineStats);
            // } else {

            if (index === -1) return;
            machineList[index].totalItems++;
            machineList[index].operator = groupV?.operator;
            // If exist, update existing entry
            machineList[index].totalPrice += item.price;
            machineList[index].totalTax += item.tax;

            machineList[index].totalPrice = parseFloat(machineList[index].totalPrice.toFixed(2));
            machineList[index].totalTax = parseFloat(machineList[index].totalTax.toFixed(2));
            // }
          });
          //calculate the final price
          let sf = 0;
          let ts = 0;

          // console.log('groupV', groupV);
          let tolerance = groupV?.tolerance ? groupV?.tolerance : 0;
          let license_fee = groupV.license_fee ? groupV.license_fee : 0;

          console.log('machineList', machineList);

          //filter the machines with tolerance
          let filtered = machineList;
          if (tolerance !== -1) {
            filtered = machineList.filter((mc) => {
              if (tolerance < mc.totalPrice) {
                return mc;
              }
            });
          }
          setFiltered(filtered);
          filtered.forEach((mc) => {
            ts += mc.totalPrice;
            if (tolerance !== -1) {
              sf += license_fee;
              // console.log('license_fee', sf);
            } else {
              if (tolerance < mc.totalPrice) {
                sf += license_fee;
              }
            }
          });

          const totalMonth = monthsBetween(startDate, endDate);
          setTotalMonth(totalMonth);
          sf = sf * totalMonth;

          ts = parseFloat(ts.toFixed(2));
          sf = parseFloat(sf.toFixed(2));
          setTotalSales(ts);
          setServiceFee(sf);
          setMS(machineList);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log('err', err);
        Swal.fire({
          title: 'Get Data Failed',
          text: err,
        });
        setIsLoading(false);
      });
  };

  const DownloadInvoice = () => {
    // var opt = {
    //   margin: 0.1,
    //   filename: 'myfile.pdf',
    //   image: { type: 'jpeg', quality: 1 },
    //   html2canvas: { scale: 2, useCORS: true },
    //   jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
    // };
    // const input = document.getElementById('download-invoice-magex-content');
    // if (input) {
    //   html2pdf().from(input).set(opt).save();
    // }
    setIsLoading(true);
    request({
      method: 'post',
      url: '/magex/downloadInvoice',
      responseType: 'blob',
      data: {
        startDate: moment(new Date(startDate)).format('YYYY-MM-DD'),
        endDate: moment(new Date(endDate)).format('YYYY-MM-DD'),
        users: [groupV],
        invoiceNO: invoiceNO,
      },
    })
      .then(async (res) => {
        const pdfData = await res.data;
        setPdf(pdfData);
        setIsLoading(false);
      })
      .catch((err) => {
        Swal.fire({
          title: 'Download Invoice Failed',
          text: err,
        });
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (pdf) {
      const url = window.URL.createObjectURL(new Blob([pdf]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `${groupV?.name}_${moment(new Date(startDate)).format('YYYYMMDD')}_${moment(
          new Date(endDate)
        ).format('YYYYMMDD')}_Invoice.pdf`
      );
      document.body.appendChild(link);
      link.click();
    }
  }, [pdf]);

  const createdAndSaveInvoice = () => {
    const std = moment(new Date(startDate)).format('YYYY-MM-DD');
    const edt = moment(new Date(endDate)).format('YYYY-MM-DD');
    request({
      method: 'post',
      url: '/magex/sendMagexInvoice',
      data: {
        users: [groupV],
        startDate: std,
        endDate: edt,
        invoiceNO: invoiceNO,
        filename: filename,
      },
    })
      .then((res) => {
        Swal.fire({
          text: 'Susscess to create invoice',
        });
      })
      .catch((err) => {
        Swal.fire({
          text: 'Failed to create invoice',
        });
      });
  };

  return (
    <ModernPageContainer>
      {loading && <LoadingIcon />}

      <ModernPageHeader
        title="Magex Sales"
        subtitle="View sales statistics and generate invoices"
        icon={ReceiptIcon}
      />

      <Paper
        sx={{
          p: 3,
          mt: 3,
          borderRadius: 3,
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Grid container spacing={2} alignItems="center">
          <Grid xs={4} item container justifyContent="flex-start">
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={startDate}
                onChange={(e) => handleStartDate(e)}
                label="Select start date"
                format="MM/dd/yyyy"
                slotProps={{
                  textField: {
                    margin: 'normal',
                    id: 'date-picker-start',
                    sx: { mr: 1 },
                  },
                }}
              />
              <DatePicker
                value={endDate}
                onChange={(e) => handleEndDate(e)}
                label="Select end date"
                format="MM/dd/yyyy"
                slotProps={{
                  textField: {
                    margin: 'normal',
                    id: 'date-picker-end',
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid
            xs={4}
            item
            container
            justifyContent="flex-start"
            alignContent="center"
            alignItems="center"
          >
            <Autocomplete
              value={groupV}
              options={groups}
              onChange={(event, value) => {
                setgroupV(value);
              }}
              isOptionEqualToValue={(option, value) => option._id === value._id}
              getOptionLabel={(option) => (option?.operator ? option?.operator : '')}
              fullWidth
              renderInput={(params) => <TextField {...params} variant="outlined" label="Customers" />}
            />
          </Grid>
          <Grid item xs={1} sx={{ ml: 2 }}>
            {!props.compare && (
              <Button
                sx={{ height: '40px' }}
                onClick={handleChange}
                disabled={!groupV?.name}
                variant="contained"
                color="primary"
              >
                Submit
              </Button>
            )}
          </Grid>
        </Grid>
      </Paper>

      <Box sx={{ mt: 4 }}>
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12} md={6}>
            <Paper
              sx={{
                p: 3,
                borderRadius: 3,
                background: `linear-gradient(135deg, ${alpha(
                  theme.palette.success.main,
                  0.1
                )} 0%, ${alpha(theme.palette.success.dark, 0.05)} 100%)`,
                border: `2px solid ${alpha(theme.palette.success.main, 0.3)}`,
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <AttachMoneyIcon sx={{ fontSize: 48, color: theme.palette.success.main }} />
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    Service Fee
                  </Typography>
                  <Typography variant="h4" sx={{ fontWeight: 700, color: theme.palette.success.dark }}>
                    ${serviceFee}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper
              sx={{
                p: 3,
                borderRadius: 3,
                background: `linear-gradient(135deg, ${alpha(
                  theme.palette.primary.main,
                  0.1
                )} 0%, ${alpha(theme.palette.primary.dark, 0.05)} 100%)`,
                border: `2px solid ${alpha(theme.palette.primary.main, 0.3)}`,
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <ShoppingCartIcon sx={{ fontSize: 48, color: theme.palette.primary.main }} />
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    Total Sales
                  </Typography>
                  <Typography variant="h4" sx={{ fontWeight: 700, color: theme.palette.primary.dark }}>
                    ${totalSales}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>
        </Grid>

        <Paper sx={{ p: 3, mb: 3, borderRadius: 3, border: `1px solid ${theme.palette.divider}` }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <BuildIcon sx={{ fontSize: 20, color: theme.palette.text.secondary }} />
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Tolerance
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    ${groupV?.tolerance}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <DescriptionIcon sx={{ fontSize: 20, color: theme.palette.text.secondary }} />
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    License Fee
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    ${groupV?.license_fee}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CalendarMonthIcon sx={{ fontSize: 20, color: theme.palette.text.secondary }} />
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Months
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    {totalMonth}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <ComputerIcon sx={{ fontSize: 20, color: theme.palette.text.secondary }} />
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Machine Num
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    {filtered.length}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Paper>

        <ModernTable
              title="Machine Statistics"
              columns={columns}
              data={ms}
              actions={[
                {
                  tooltip: 'Download cvs',
                  isFreeAction: true,
                  icon: CloudDownload,
                  onClick: (evt, rowData) => {
                    let outPutArray = [...ms];
                    outPutArray = outPutArray.map((item) => {
                      return {
                        Machine: item.machineId,
                        Sales: item.totalPrice,
                        Tax: item.totalTax,
                        'Items Sold': item.totalItems,
                      };
                    });
                    const options = {
                      fieldSeparator: ',',
                      quoteStrings: '"',
                      decimalSeparator: '.',
                      useTextFile: false,
                      filename: 'Sales Report CSV(per item)',
                      useKeysAsHeaders: true,
                    };
                    console.log('outPutArray', outPutArray);
                    const csvExporter = new ExportToCsv(options);
                    csvExporter.generateCsv(outPutArray);
                  },
                },
              ]}
              options={{
                pageSize: 10,
                pageSizeOptions: [10, 20, 50, 100],
              }}
            />

        <Paper sx={{ p: 3, mt: 3, borderRadius: 3, border: `1px solid ${theme.palette.divider}` }}>
          <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
            Invoice Actions
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap' }}>
            <Button
              sx={{ height: '40px' }}
              onClick={showInvoice}
              disabled={!groupV?.name}
              variant="contained"
              color="primary"
              startIcon={<ReceiptIcon />}
            >
              Get Invoice
            </Button>
            <Button
              sx={{ height: '40px' }}
              onClick={DownloadInvoice}
              disabled={!enableDownLoad}
              variant="contained"
              color="primary"
              startIcon={<CloudDownloadIcon />}
            >
              Download Invoice
            </Button>
            <Button
              sx={{ height: '40px' }}
              onClick={createdAndSaveInvoice}
              disabled={!enableDownLoad || !filename}
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
            >
              Create and Save Invoice
            </Button>
            <Button
              sx={{ height: '40px' }}
              onClick={sendInvoice}
              disabled={!enableDownLoad}
              variant="contained"
              color="primary"
              startIcon={<SendIcon />}
            >
              Send Invoice
            </Button>
          </Box>

          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} md={6}>
              <TextField
                variant="outlined"
                fullWidth
                label="Invoice Number"
                value={invoiceNO}
                onChange={(e) => {
                  setInvoiceNO(e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                variant="outlined"
                fullWidth
                label="Filename"
                value={filename}
                onChange={(e) => {
                  setFilename(e.target.value);
                }}
              />
            </Grid>
          </Grid>

          <Box id="download-invoice-magex-content">
            <div id="invoicetpmagex"></div>
            <div id="tmc_magexinvoice"></div>
          </Box>
        </Paper>
      </Box>
    </ModernPageContainer>
  );
}
